import { Box, Button, Grid, Pagination, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import {
  OutreachContactsContext,
  ScheduledType,
} from "contexts/OutreachContacts";
import { useContext } from "react";

import { usePageSize } from "utils/usePageSize";

import ScheduledContact from "../ScheduledContact";
import HalfScreenPreviewCard from "../ScheduledThreadPreview/HalfScreenPreviewCard";
import CancelAllButton from "./CancelAll";
import styles from "./styles";

interface Props {
  totalPages: number;
  isSmallScreen: boolean;
  sidebarOpen: boolean;
}

const ScheduledSidebar = ({
  totalPages,
  isSmallScreen,
  sidebarOpen,
}: Props) => {
  const { currentContact } = useContext(OutreachContactsContext);
  const {
    contacts,
    handleFetchContacts,
    fetchContactsParams,
    scheduledTotals,
    setCurrentContact,
  } = useContext(OutreachContactsContext);

  const totalOutreach = scheduledTotals[ScheduledType.outreach] ?? 0;
  const totalFollowup = scheduledTotals[ScheduledType.followUp] ?? 0;

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    const updatedParams = { ...fetchContactsParams };
    updatedParams.page = value;
    handleFetchContacts(updatedParams);
  };

  const handleClick = (scheduledType: ScheduledType) => {
    setCurrentContact(null);
    const updatedParams = { ...fetchContactsParams, scheduledType, page: 1 };
    handleFetchContacts(updatedParams);
  };

  const { hasBanner } = usePageSize();

  return (
    <Grid container sx={styles.container}>
      <Box sx={styles.header}>
        <Grid container alignItems="center" justifyContent={"space-between"}>
          {!isSmallScreen && (
            <>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ my: { xs: 0, md: 1.5 } }}
              >
                Scheduled Emails
              </Typography>
              <CancelAllButton />
            </>
          )}
        </Grid>

        <Grid container sx={{ ml: -1 }} justifyContent={"space-between"}>
          <Box>
            <Button
              onClick={() => handleClick(ScheduledType.outreach)}
              sx={[
                styles.buttonTab,
                fetchContactsParams.scheduledType === ScheduledType.outreach
                  ? styles.active
                  : {},
              ]}
            >
              Outreach ({totalOutreach})
            </Button>
            <Button
              onClick={() => handleClick(ScheduledType.followUp)}
              sx={[
                styles.buttonTab,
                fetchContactsParams.scheduledType === ScheduledType.followUp
                  ? styles.active
                  : {},
              ]}
            >
              Follow-ups ({totalFollowup})
            </Button>
          </Box>

          {isSmallScreen && (
            <Pagination
              size="small"
              count={totalPages}
              page={fetchContactsParams.page}
              onChange={handleChange}
            />
          )}
        </Grid>
      </Box>

      <Box sx={styles.body(hasBanner)}>
        {contacts?.length === 0 && (
          <Typography textAlign="center" sx={{ color: grey[500], p: 3 }}>
            You don't have any scheduled {fetchContactsParams.scheduledType} at
            this time.
          </Typography>
        )}
        {contacts?.map((contact) => (
          <ScheduledContact contact={contact} />
        ))}
      </Box>

      {!isSmallScreen && contacts?.length > 0 && (
        <Box sx={styles.footer}>
          <Pagination
            count={totalPages}
            page={fetchContactsParams.page}
            onChange={handleChange}
          />
        </Box>
      )}

      {isSmallScreen && !sidebarOpen && currentContact?.id && (
        <HalfScreenPreviewCard />
      )}
    </Grid>
  );
};

export default ScheduledSidebar;
